(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/draft-to-lexical.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/draft-to-lexical.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DRAFT_STYLE_TO_LEXICAL_FORMAT = {
  BOLD: 1,
  ITALIC: 2,
  STRIKETHROUGH: 4,
  UNDERLINE: 8,
  CODE: 16
};
function buildFormatBitmask(styles) {
  let format = 0;
  for (let i = 0; i < styles.length; i++) {
    format |= DRAFT_STYLE_TO_LEXICAL_FORMAT[styles[i]] || 0;
  }
  return format;
}
function convertInlineStylesToTextNodes(text, inlineStyleRanges) {
  if (!text) {
    return [];
  }
  if (!inlineStyleRanges || inlineStyleRanges.length === 0) {
    return [{
      detail: 0,
      format: 0,
      mode: 'normal',
      style: '',
      text,
      type: 'text',
      version: 1
    }];
  }

  const charStyles = new Array(text.length);
  for (let i = 0; i < text.length; i++) {
    charStyles[i] = [];
  }
  for (const range of inlineStyleRanges) {
    const end = Math.min(range.offset + range.length, text.length);
    for (let i = range.offset; i < end; i++) {
      charStyles[i].push(range.style);
    }
  }

  const nodes = [];
  let currentFormat = buildFormatBitmask(charStyles[0]);
  let currentStart = 0;
  for (let i = 1; i <= text.length; i++) {
    const nextFormat = i < text.length ? buildFormatBitmask(charStyles[i]) : -1;
    if (nextFormat !== currentFormat) {
      const code = text.charCodeAt(i);
      if (code >= 0xDC00 && code <= 0xDFFF) {
        continue;
      }
      nodes.push({
        detail: 0,
        format: currentFormat,
        mode: 'normal',
        style: '',
        text: text.slice(currentStart, i),
        type: 'text',
        version: 1
      });
      currentStart = i;
      currentFormat = nextFormat;
    }
  }
  return nodes;
}
function convertBlockToLexicalNode(block) {
  const children = convertInlineStylesToTextNodes(block.text, block.inlineStyleRanges);
  const baseProps = {
    children,
    direction: children.length > 0 ? 'ltr' : null,
    format: '',
    indent: 0,
    version: 1
  };
  switch (block.type) {
    case 'blockquote':
      return _objectSpread(_objectSpread({}, baseProps), {}, {
        type: 'quote'
      });
    case 'header-one':
      return _objectSpread(_objectSpread({}, baseProps), {}, {
        type: 'heading',
        tag: 'h1'
      });
    case 'header-two':
      return _objectSpread(_objectSpread({}, baseProps), {}, {
        type: 'heading',
        tag: 'h2'
      });
    case 'header-three':
      return _objectSpread(_objectSpread({}, baseProps), {}, {
        type: 'heading',
        tag: 'h3'
      });
    case 'unordered-list-item':
    case 'ordered-list-item':
      return {
        children,
        direction: children.length > 0 ? 'ltr' : null,
        format: '',
        indent: block.depth || 0,
        type: 'listitem',
        value: 1,
        version: 1
      };
    default:
      return _objectSpread(_objectSpread({}, baseProps), {}, {
        type: 'paragraph'
      });
  }
}
function convertDraftToLexical(draftRaw) {
  const blocks = draftRaw.blocks || [];
  const rootChildren = [];
  let currentList = null;
  let currentListType = null;
  for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i];
    const isListItem = block.type === 'unordered-list-item' || block.type === 'ordered-list-item';
    if (isListItem) {
      const lexicalListType = block.type === 'unordered-list-item' ? 'bullet' : 'number';
      const tag = block.type === 'unordered-list-item' ? 'ul' : 'ol';
      if (currentList && currentListType === block.type) {
        const listItem = convertBlockToLexicalNode(block);
        listItem.value = currentList.children.length + 1;
        currentList.children.push(listItem);
      } else {
        if (currentList) {
          rootChildren.push(currentList);
        }
        const listItem = convertBlockToLexicalNode(block);
        currentList = {
          children: [listItem],
          direction: 'ltr',
          format: '',
          indent: 0,
          listType: lexicalListType,
          start: 1,
          tag,
          type: 'list',
          version: 1
        };
        currentListType = block.type;
      }
    } else {
      if (currentList) {
        rootChildren.push(currentList);
        currentList = null;
        currentListType = null;
      }
      rootChildren.push(convertBlockToLexicalNode(block));
    }
  }

  if (currentList) {
    rootChildren.push(currentList);
  }

  if (rootChildren.length === 0) {
    rootChildren.push({
      children: [],
      direction: null,
      format: '',
      indent: 0,
      type: 'paragraph',
      version: 1
    });
  }
  return {
    root: {
      children: rootChildren,
      direction: 'ltr',
      format: '',
      indent: 0,
      type: 'root',
      version: 1
    }
  };
}
function isDraftFormat(json) {
  return json && Array.isArray(json.blocks) && json.entityMap !== undefined;
}
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.convertDraftToLexical', convertDraftToLexical);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.isDraftFormat', isDraftFormat);

 })(window);